import { createSlice } from '@reduxjs/toolkit';
import { reducers as extraReducers } from './copyTemplate.reducer';

export enum Environment {
  Global = 'GLOBAL',
  Trial = 'TRIAL',
  Australia = 'AUSTRALIA',
  EuropeUnion = 'EUROPE_UNION',
  Lite = 'LITE',
}

export interface ICopyTemplateState {
  loading: boolean;
  projectId: string | null;
  env: Environment | null;
}

const initialState: ICopyTemplateState = {
  loading: false,
  projectId: null,
  env: null
};

const copyTemplateSlice = createSlice({
  name: 'copyTemplate',
  initialState,
  reducers: {},
  extraReducers
});

export const copyTemplateReducer = copyTemplateSlice.reducer;